import { makeStyles } from '@material-ui/core';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

export const useStyles = makeStyles((theme: ITheme) => ({
  widget: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginRight: 24,
    },
    verticalAlign: 'middle',
  },
  separator: {
    color: colors.lightGray,
  },
  iconWrapper: {
    verticalAlign: 'middle',
    marginTop: 8,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  walletIcon: {
    marginLeft: theme.spacing(1),
  },
  walletLink: {
    fontWeight: 700,
    color: colors.darkestBlue,
    padding: '0 8px',
  },
}));
